import { Component, Vue, Mixins, Watch, Prop } from 'vue-property-decorator'
import TaskDetailTemplate from './TaskDetailTemplate.vue'
import TaskApi from '@/api/task'
import Task from '@/web-task'
import watermark from '@/utils/watermark'

Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteUpdate',
	'beforeRouteLeave',
])

@Component({
	components: {
		TaskDetailTemplate,
	},
})
export default class AddTaskMixin extends Vue {
	private task: any = ''
	private taskType: any = ''
	private order: any = null
	private injured: any = null

	private async init() {
		// 路由中taskType无值时处理
		if (this.$route.params.taskType === 'undefined') {
			try {
				await this.getDetail()
			} catch (err) {
				console.error('getDetail failed: ', err)
				return
			}
		}
		let taskType = this.taskType || this.$route.params.taskType
		this.task = new Task({
			propsData: {
				order: {
					taskType,
				},
			},
		})

		// 读取路由中的 watermark 参数并显示水印
		const wm = this.$route.params.watermark
		if (wm) {
			watermark.init({
				watermark_txt: wm,
				watermark_width: 200,
				watermark_x: 0,
				watermark_y: 0,
				watermark_x_space: 50,
				watermark_y_space: 50,
				watermark_alpha: 0.05,
				watermark_fontsize: '30px',
				watermark_angle: 35,
			})
		}
	}

	public getDetail() {
		return TaskApi.getOpenDetail(
			this.$route.params.orderId,
			this.$route.params.key
		).then((data: any) => {
				if (data.code === 200) {
					this.taskType = data.data.order && data.data.order.taskType
				} else if (data.code === 503 && data.message === '权限不足，操作非法') {
					this.$store.dispatch('user/Logout').then(() => {
						window.location.replace(`${location.origin}/passport/login`)
					})
				} else {
					this.$notification.error({
						message: '错误',
						description: data.message,
					})
				}
			}
		)
	}

	private created() {
		// 用于该公共组件不处于keep-alive中时
		this.init()
	}

	private activated() {
		this.init()
	}

	private beforeRouteLeave(to: any, from: any, next: any) {
		this.task = ''
		this.removeWatermark()
		next()
	}

	private beforeRouteUpdate(to: any, from: any, next: any) {
		this.task = ''
		this.removeWatermark()
		this.$nextTick(() => {
			this.init()
		})
		next()
	}

	private removeWatermark() {
		try {
			watermark.remove()
		} catch (err) {
			// 忽略报错
		}
	}
}
